import type { CartState } from "./CartType.js";

export function cartWithAppliedProperties<T extends CartState>(cart: T): T {
	return {
		...cart,
	};
}
